export const UPDATE_MANDATO_RICERCA            	= 'UPDATE_MANDATO_RICERCA';
export const UPDATE_COGNOME_RICERCA            	= 'UPDATE_COGNOME_RICERCA';
export const UPDATE_NOME_RICERCA 			  	= 'UPDATE_NOME_RICERCA';
export const UPDATE_UTENTE_RICERCA 	   	      	= 'UPDATE_UTENTE_RICERCA';
export const UPDATE_PROFILO_RICERCA 	   	    = 'UPDATE_PROFILO_RICERCA';
export const UPDATE_DATA_CREAZIONE_RICERCA 	  	= 'UPDATE_DATA_CREAZIONE_RICERCA';
export const UPDATE_DATA_SCADENZA_RICERCA 	    = 'UPDATE_DATA_SCADENZA_RICERCA';
export const UPDATE_DATA_ULTIMO_ACCESSO_RICERCA = 'UPDATE_DATA_ULTIMO_ACCESSO_RICERCA';
export const SELEZIONA_DETTAGLIO_UTENTE 		= 'SELEZIONA_DETTAGLIO_UTENTE';
